import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useVipAvailability = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () =>
      axios.get(`${API}/silvester/vip-availability`).then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return data;
};

export const VipAvailabilityBar = ({ data }) => {
  if (!data) return null;
  const { free, capacity_open: open } = data;
  const pct = open > 0 ? Math.round(((open - free) / open) * 100) : 100;

  if (free <= 0) {
    return (
      <div className="mb-6 text-center" data-testid="vip-sold-out-badge">
        <span className="inline-block px-5 py-2 rounded-full bg-red-600 text-white font-semibold tracking-wide">Ausverkauft</span>
      </div>
    );
  }

  return (
    <div className="mb-6" data-testid="vip-availability">
      <div className="flex items-center justify-between text-sm mb-2">
        <span className="flex items-center gap-2 font-medium text-slate-800">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
          </span>
          <span data-testid="vip-free-text">Noch {free} von {open} Plätzen frei</span>
        </span>
        <span className="text-slate-500 tabular-nums">{pct}% gebucht</span>
      </div>
      <div className="h-2.5 w-full rounded-full bg-amber-200/70 overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-amber-500 to-orange-500 transition-[width] duration-700"
          style={{ width: `${Math.max(pct, 2)}%` }}
          data-testid="vip-availability-bar"
        />
      </div>
    </div>
  );
};
